export class PagedRequestDTO {
  entityClass: string;
  pageNumber: number;
  pageSize: number;
  sortField: string;
  sortDirection: string;
  fieldMap: {};
}
